import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReplacementDriver } from '~models/user';

export interface LmoOrdersReplacementDriverOnOrderDialogResult {
  shouldComplete: boolean;
  shouldSubmit: boolean;
}

@Component({
  selector: 'sa-lmo-orders-replacement-driver-on-order',
  styleUrls: ['./lmo-orders-replacement-driver-on-order.component.scss'],
  templateUrl: './lmo-orders-replacement-driver-on-order.component.html',
})
export class LmoOrdersReplacementDriverOnOrderComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { driver: ReplacementDriver },
    public dialogRef: MatDialogRef<LmoOrdersReplacementDriverOnOrderComponent>,
  ) {}

  public completeLoad() {
    this.dialogRef.close({
      shouldComplete: true,
      shouldSubmit: true,
    });
  }

  public cancelLoad() {
    this.dialogRef.close({
      shouldComplete: false,
      shouldSubmit: true,
    });
  }

  public goBack() {
    this.dialogRef.close({
      shouldComplete: false,
      shouldSubmit: false,
    });
  }
}
